<template>
  <v-dialog v-model="dialogShow"  persistent width="520" height="285">
    <v-card style="background-color: rgba(26, 31, 41, 1)">
      <v-card-title style="border-bottom:1px solid rgba(37, 46, 79, 1);" class="dialogTitle">
        <p style="color: white">图层上传</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" style="color: rgba(196,196,196,1)" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:41px 48px 30px 39px;">
        <div style="display:flex;align-items:center;">
          <p style="font-size:16px;color:rgb(229, 229, 229);">名称</p>
          <v-text-field class="custom-text-field" v-model="layerName" maxlength="12" placeholder="影像名称不超过12个字" dense outlined hide-details width="339" height="36" style="margin-left:30px;background-color: rgb(35, 43, 59);color: white"></v-text-field>
        </div>
        <div style="display:flex;align-items:center;margin-top: 15px;">
          <p style="font-size:16px;color:rgb(229, 229, 229);">路径</p>
          <v-text-field class="custom-text-field" v-model="layerUrl" placeholder="URL" dense outlined hide-details width="339" height="36" style="margin-left:30px;background-color: rgb(35, 43, 59);color: white"></v-text-field>
        </div>
<!--        <p :style="{'visibility':errorShow ? 'visible' : 'hidden'}" style="margin-left:93px;margin-top:5px;font-size:14px;color:#ff0000;"><span class="iconfontFamily">&#xe71f;</span>{{errorText}}</p>-->
        <div style="margin-top:58px;text-align:right;">
          <v-btn @click="confirmUploadLayer" width="100" height="33" dark color="#1E3A8A">确认上传</v-btn>
        </div>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: "ImportLayerDialog",
  props:["dialogShow"],
  data(){
    return{

      layerName:"",
      layerUrl: '',

      errorShow:false,
      errorText:"",


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },
    confirmUploadLayer() {
      if (this.layerName.length > 12) {
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "影像名称不超过12个字"
        this.$store.state.snackbarType = 'error'
        return
      }
      this.$axios({
        method: 'get',
        url: '/authorApi/z-geo-file-layer/addZGeoFileLayer',
        params: {
          layer: this.layerUrl,
          name: this.layerName,
          fileId: this.$store.state.currFolderId,
        }
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.$emit('importLayerOk')
        } else {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = resp.message
          this.$store.state.snackbarType = 'error'
        }
      })
    },
  },
  mounted(){
  }

}
</script>

<style scoped>
/* 修改文字颜色 */
::v-deep .custom-text-field .v-input__control input {
  color: white !important;
}

/* 修改 placeholder 颜色 */
::v-deep .custom-text-field .v-input__control input::placeholder {
  color: rgb(128, 128, 128) !important;
  opacity: 1;
}

</style>